export default __webpack_public_path__ + "static/media/EUR.7e19415f.svg";